import "./partners.css";
import React from "react";
import { motion } from "framer-motion";
import {
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  travelcard_image2,
} from "../../assets/images/images";
import { useTranslation } from 'react-i18next'; // Import useTranslation

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const staggerLogos = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

const logoVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
};

export default function Partners() {
  const { t, i18n  } = useTranslation(); // Use the useTranslation hook
  const isRTL = i18n.language === 'ar'; // Check if current language is RTL
  return (
    <motion.div
      className="Partners"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <motion.div className="left_part" variants={fadeIn}>
        <div className="informations">
          <motion.p className="title" variants={fadeIn}>
            {t('partners.title')}
          </motion.p>
          <motion.p className="disc" variants={fadeIn}>
            {t('partners.description')}
          </motion.p>
        </div>
        <motion.div className="logos" variants={staggerLogos}>
          {[logo1, logo2, logo3, logo4, logo5, logo6].map((logo, i) => (
            <motion.div key={i} className="logo" variants={logoVariants}>
              <img src={logo} alt={`partner-${i + 1}`} loading="lazy" />
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
      <motion.div
        className="right_part"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        <img src={travelcard_image2} alt="travel" loading="lazy" />
      </motion.div>
    </motion.div>
  );
}